"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.snakeToKebab = exports.parseAttribute = void 0;
const findAttribute_1 = __importDefault(require("./findAttribute"));
const snakeToKebab = (str) => {
    return str.replace(/_/g, '-');
};
exports.snakeToKebab = snakeToKebab;
const parseAttribute = (attribute, type) => {
    if (attribute === null) {
        return null;
    }
    switch (type) {
        case 'string':
            return attribute;
        case 'integer':
            return parseInt(attribute);
        case 'float':
            return parseFloat(attribute);
        case 'boolean':
            return attribute === 'true';
    }
};
exports.parseAttribute = parseAttribute;
const createDynamicContextFunction = (entity) => {
    return (element) => {
        const { entityPath, properties } = entity;
        const data = {};
        properties.forEach((p) => {
            const { name, type } = p;
            const attributeProperty = snakeToKebab(name);
            const attribute = (0, findAttribute_1.default)(element, `data-snowplow-${attributeProperty}`);
            const parsedAttribute = parseAttribute(attribute, type);
            if (parsedAttribute !== null) {
                if (typeof parsedAttribute === 'number' && isNaN(parsedAttribute)) {
                    const printableAttribute = attribute !== null ? attribute : 'null';
                    console.warn(`Invalid value for attribute ${name}: ${printableAttribute}`);
                }
                else {
                    data[name] = parsedAttribute;
                }
            }
        });
        return {
            schema: entityPath,
            data,
        };
    };
};
exports.default = createDynamicContextFunction;
//# sourceMappingURL=data:application/json;base64,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


// WEBPACK FOOTER //
// ../../../../src/utils/dynamicContext/createDynamicContextFunction.ts